import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="payment-methods"
export default class extends Controller {
  static targets = ['paymentMethod'];

  setFormAction() {
    const selected = this.paymentMethodTargets.find(e => e.checked);

    this.element.action = selected.dataset.linksTo;
  }
}
